import { ConfigService } from '@akebono/core';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AutoLotView } from '../../../const';

type LotExtraInfo = string | Record<string, string>;

@Component({
  selector: 'app-lot-extra-info',
  templateUrl: './lot-extra-info.component.html',
  styleUrls: ['./lot-extra-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotExtraInfoComponent implements OnInit {
  @Input() lot: AutoLotView;
  @Input() active = false;

  info$: Observable<LotExtraInfo> = null;
  switchSubject$ = new BehaviorSubject<Boolean>(true);
  canTranslateDescription = false;

  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    const { parsedData, parsedDataEn, parsedDataRu } = this.lot;

    this.switchSubject$.next(
      this.configService.getCurrentLanguage().localeId === 'ru' && parsedDataRu,
    );
    this.canTranslateDescription = parsedDataEn || parsedDataRu;

    this.info$ = combineLatest([
      this.configService.getCurrentLanguage$(),
      this.switchSubject$,
    ]).pipe(
      map(([lang, translated]) => {
        let infoString: string | null = null;

        if (!translated) {
          infoString = parsedData || parsedDataEn || parsedDataRu;
        } else if (lang.localeId === 'ru' && parsedDataRu) {
          infoString = parsedDataRu;
        } else {
          infoString = parsedDataEn || parsedData || parsedDataRu;
        }

        try {
          return JSON.parse(infoString?.replace('<![CDATA', '')?.replace('}]]>', '}]'))[0];
        } catch {
          return infoString;
        }
      }),
    );
  }

  isRecordInfo(info: LotExtraInfo): boolean {
    return typeof info === 'object';
  }
}
